import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import store, { ASYNC_USER_LOAD_DATA, SET_AREA, history } from 'store';
import { ConnectedRouter } from 'connected-react-router';
import { connect } from 'react-redux';
import { api } from 'services';
import { PublicRoutes, PrivateRoutes } from './routes';
import { ToastContainer } from 'react-toastify';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './style.scss';

import Loading from 'components/Loading';
import PrivateRoute from 'helpers/PrivateRoute';

const Routes = connect(
  (state) => ({
    isLogged: state.user.authenticate,
    pathname: state.router.location.pathname,
    isLoading: state.loading,
    area: state.area,
  }),
  (dispatch) => ({
    setArea: (payload) => dispatch({ type: SET_AREA, payload }),
  })
)(({ isLogged, pathname, isLoading, area, setArea }) => {
  useEffect(()=>{
    localStorage.removeItem('expired');
  },[]);
  useEffect(() => {
    if (isLogged && !area && !!localStorage.area_id) {
      api
        .get(`/areas/${localStorage.area_id}`)
        .then(({ data }) => setArea(data));
    }
  }, [area, setArea, isLogged]);

  if (!!localStorage.token && !isLogged) return <Loading />;

  if (!area && !!localStorage.area_id) return <Loading />;

  if (pathname !== '/select-area' && isLogged && !area && !localStorage.area_id)
    return <Redirect to="/select-area" />;

  return (
    <>
      <ToastContainer />

      {/* { isLoading ? <Loading /> : null } */}

      {PublicRoutes.map((route, k) => (
        <Route
          key={k}
          exact={!!route.exact}
          path={route.pathname}
          component={route.component}
          {...route.props}
        />
      ))}

      {PrivateRoutes.map((route, k) => (
        <PrivateRoute
          key={k}
          exact={!!route.exact}
          path={route.pathname}
          component={route.component}
          {...route.props}
          permission={route.permission}
        />
      ))}
    </>
  );
});

const App = () => {
  useEffect(() => {
    if (!!localStorage.token) store.dispatch({ type: ASYNC_USER_LOAD_DATA });
  }, []);

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Routes />
        </Switch>
      </ConnectedRouter>
    </Provider>
  );
};

export default App;
